import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Fitnesses = () => {
  const [searchParams] = useSearchParams();
  const user_id = searchParams.get('user_id');
  const { fetchWithAuth } = useAuth();
  
  const [fitnesses, setFitnesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 20;

  useEffect(() => {
    fetchFitnesses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, user_id]);

  const fetchFitnesses = async () => {
    setLoading(true);
    try {
      const url = user_id 
        ? `/api/fitnesses?page=${page}&limit=${limit}&user_id=${user_id}`
        : `/api/fitnesses?page=${page}&limit=${limit}`;
      
      const response = await fetchWithAuth(url);
      if (!response.ok) throw new Error('Failed to fetch fitness records');
      const data = await response.json();
      setFitnesses(data.data);
      setTotal(data.total);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const totalPages = Math.ceil(total / limit);

  if (loading && fitnesses.length === 0) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div>
      <h1 style={{ fontSize: '32px', fontWeight: '700', marginBottom: '24px' }}>
        Fitness Goals {user_id && `- User ${user_id}`}
      </h1>

      {user_id && (
        <div style={{ marginBottom: '16px' }}>
          <Link to="/fitnesses" className="link">← View All Fitness Goals</Link>
        </div>
      )}

      <div className="card">
        <div style={{ marginBottom: '16px', color: '#666' }}>
          {total} total records
        </div>

        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>User</th>
                <th>Target Weight</th>
                <th>Daily Calories</th>
                <th>Protein</th>
                <th>Carbs</th>
                <th>Fat</th>
                <th>Goal</th>
                <th>Level</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {fitnesses.map((fitness) => (
                <tr key={fitness.id}>
                  <td>{fitness.id}</td>
                  <td>
                    <Link to={`/users/${fitness.user_id}`} className="link">
                      {fitness.user_name || `User ${fitness.user_id}`}
                    </Link>
                  </td>
                  <td>{fitness.target_weight_kg ? `${fitness.target_weight_kg} kg` : 'N/A'}</td>
                  <td>{fitness.daily_calories ? `${Math.round(fitness.daily_calories)} kcal` : 'N/A'}</td>
                  <td>{fitness.daily_protein ? `${Math.round(fitness.daily_protein)}g` : 'N/A'}</td>
                  <td>{fitness.daily_carbs ? `${Math.round(fitness.daily_carbs)}g` : 'N/A'}</td>
                  <td>{fitness.daily_fat ? `${Math.round(fitness.daily_fat)}g` : 'N/A'}</td>
                  <td>{fitness.goal || 'N/A'}</td>
                  <td>{fitness.fitness_level || 'N/A'}</td>
                  <td>{formatDate(fitness.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <button
            className="btn btn-secondary"
            onClick={() => setPage(page - 1)}
            disabled={page === 1}
          >
            Previous
          </button>
          <span className="page-info">
            Page {page} of {totalPages}
          </span>
          <button
            className="btn btn-secondary"
            onClick={() => setPage(page + 1)}
            disabled={page >= totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Fitnesses;


